import { Wind } from "lucide-react";

export default function Logo({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 group"
      data-testid="logo-btn"
    >
      <div className="w-9 h-9 rounded-xl bg-[var(--primary)] flex items-center justify-center group-hover:rotate-6 transition-transform">
        <Wind className="w-5 h-5 text-white" strokeWidth={2.2} />
      </div>
      <span className="font-heading text-xl tracking-tight">
        A<span className="text-[var(--accent)]">·</span>team
      </span>
    </button>
  );
}
